import React, { Component } from 'react';
import Header from './../../Header';
class Infra extends Component {
  render() {
    return(
      <div>
       <Header brecum_name="Infra" brecum_page="Infra" />
        <div class="right_col">
          <div class="ticket_list">
           <h5 class="title">Infra</h5>
           <h2>The page will comming very soon....</h2>
          </div>
        </div>
     </div>
    )
  }
  componentDidMount() {
    document.title = "Intranet | Infrastructure";
   }
  
}
export default Infra;


// WEBPACK FOOTER //
// ./src/components/infra/Infra.js